import { useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../store';
import { SitesActions } from '../store/entities/sites/sites.actions';
import { IAutoCompleteItem } from '../models/autoComplete';
import { SiteTypes } from '../models/pricingPlan';

export const useSiteOptions = (siteType?: SiteTypes): IAutoCompleteItem[] => {
  const dispatch = useAppDispatch();
  const { siteListDetails } = useAppSelector((s) => s.sites);
  const { appLanguage } = useAppSelector((s) => s.general);

  useEffect(() => {
    dispatch(SitesActions.getSiteListDetails());
  }, [dispatch]);

  const siteOptions = useMemo<IAutoCompleteItem[]>(() => {
    if (!siteListDetails?.length) return [];
    return [...siteListDetails]
      .sort((a: any, b: any) => (a.id > b.id ? 1 : -1))
      .filter(
        (site: any) =>
          site.isActive && (siteType ? site.siteTypeId === siteType : true)
      )
      .map((site: any) => ({
        id: site.id,
        label: `${site.id} - ${appLanguage === 'hebrew' ? site.nameHE : (site.nameEN ?? '')}`,
      }));
  }, [siteListDetails, appLanguage, siteType]);

  return siteOptions;
};

export default useSiteOptions;
